"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regexTransformMatchInfoToRangeInfo = exports.regexFindRangeInfoFromMatchInfo = exports.findLineBoundaries = void 0;
function findLineBoundaries(subject) {
    let processingLine = true;
    // build an array of line boundaries (start and end indexes for all linefeed characters)
    const lineBoundaries = [];
    const subjectLength = subject.length;
    for (let i = 0; i < subjectLength; i++) {
        if (subject.charAt(i) === '\n') {
            const numLineBoundaries = lineBoundaries.length;
            lineBoundaries[numLineBoundaries] = {
                startIndex: (numLineBoundaries === 0) ? 0 : lineBoundaries[numLineBoundaries - 1].endIndex + 1,
                endIndex: i
            };
            processingLine = false;
        }
        else {
            processingLine = true;
        }
    }
    const numLineBoundaries = lineBoundaries.length;
    if (processingLine == true) {
        // handle case: single line (no linefeeds detected)
        if (numLineBoundaries == 0) {
            lineBoundaries[0] = {
                startIndex: 0,
                endIndex: subjectLength - 1
            };
        }
        // handle case: last line has no linefeed
        else {
            lineBoundaries[numLineBoundaries] = {
                startIndex: lineBoundaries[numLineBoundaries - 1].endIndex + 1,
                endIndex: subjectLength - 1
            };
        }
    }
    return lineBoundaries;
}
exports.findLineBoundaries = findLineBoundaries;
function regexFindRangeInfoFromMatchInfo(matchInfo, lineBoundaries, startLineBoundaryIndex) {
    const matchStartIndex = matchInfo.index;
    const matchEndIndex = matchStartIndex + matchInfo.length - 1;
    const numLineBoundaries = lineBoundaries.length;
    let currentLineBoundaryIndex = startLineBoundaryIndex;
    // initialize object (we'll populate below)
    // note: line numbers start at 1
    const range = {
        startLineNumber: 0,
        startColumn: 0,
        endLineNumber: 0,
        endColumn: 0
    };
    let foundStart = false;
    let foundEnd = false;
    let foundRange = false;
    for (let j = currentLineBoundaryIndex; j < numLineBoundaries; j++) {
        // detect start line and column
        if (matchStartIndex >= lineBoundaries[j].startIndex && matchStartIndex <= lineBoundaries[j].endIndex) {
            range.startLineNumber = j + 1; // + 1 for line number, not an index
            range.startColumn = matchStartIndex - lineBoundaries[j].startIndex + 1; // + 1 for column number, not an index
            foundStart = true;
        }
        // detect end line and column
        if (matchEndIndex >= lineBoundaries[j].startIndex && matchEndIndex <= lineBoundaries[j].endIndex) {
            range.endLineNumber = j + 1; // + 1 for line number, not an index
            range.endColumn = matchEndIndex - lineBoundaries[j].startIndex + 1; // + 1 for column number, not an index
            foundEnd = true;
        }
        // are we finished with this submatch?
        if (foundStart === true && foundEnd === true) {
            currentLineBoundaryIndex = j;
            foundRange = true;
            break;
        }
    }
    return {
        found: foundRange,
        range: range,
        lineBoundaryIndex: currentLineBoundaryIndex
    };
}
exports.regexFindRangeInfoFromMatchInfo = regexFindRangeInfoFromMatchInfo;
function regexTransformMatchInfoToRangeInfo(subject, regexMatchInfo) {
    if (regexMatchInfo.found === false) {
        throw new Error(`The regex match info received indicated a match was not found.  Here's the regex match info: ${JSON.stringify(regexMatchInfo, null, 4)}`);
    }
    const regexRangeInfo = {
        match: {
            startLineNumber: 0,
            startColumn: 0,
            endLineNumber: 0,
            endColumn: 0
        },
        submatches: []
    };
    const lineBoundaries = findLineBoundaries(subject);
    const fullMatchRangeInfo = regexFindRangeInfoFromMatchInfo(regexMatchInfo.match, lineBoundaries, 0);
    if (fullMatchRangeInfo.found === false) {
        throw new Error(`We could not determine the full match range info for subject string ${subject}`);
    }
    else {
        // set full match range info
        regexRangeInfo.match = fullMatchRangeInfo.range;
        // build & set submatch range info
        const submatchRanges = [];
        const submatches = regexMatchInfo.submatches;
        const numSubmatches = submatches.length;
        let currentLineBoundaryIndex = 0;
        for (let i = 0; i < numSubmatches; i++) {
            const submatchRangeInfo = regexFindRangeInfoFromMatchInfo(submatches[i], lineBoundaries, currentLineBoundaryIndex);
            if (submatchRangeInfo.found === false) {
                throw new Error(`We could not determine the submatch range info for subject string ${subject} corresponding to submatch info: ${JSON.stringify(submatchRangeInfo.range, null, 4)}`);
            }
            else {
                submatchRanges[submatchRanges.length] = submatchRangeInfo.range;
                currentLineBoundaryIndex = submatchRangeInfo.lineBoundaryIndex;
            }
        }
        regexRangeInfo.submatches = submatchRanges;
    }
    return regexRangeInfo;
}
exports.regexTransformMatchInfoToRangeInfo = regexTransformMatchInfoToRangeInfo;
